module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_news_post-politics_wp_2016_10_02_as-news-of-trumps-taxes-broke-he-goes-off-script-at-a-rally-in-pennsylvania__plot.74b0cc52.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_news_post-politics_wp_2016_10_02_as-news-of-trumps-taxes-broke-he-goes-off-script-at-a-rally-in-pennsylvania__plot.png
// module id = 433
// module chunks = 0